import axios from "axios";
import ConsoleLocalStorage from "../storage/storage";
import { APP_MANAGEMENT_URL } from "../config";

export default class DevSdkRepoAPI {
  instance = axios.create({
    baseURL: APP_MANAGEMENT_URL,
    headers: {
      Authorization: "Bearer " + ConsoleLocalStorage.getAccessToken(),
    },
  });
  getAllSdkRepo(pageNumber, pageSize) {
    return this.instance.get(
      "sdk-packages" +
        `${pageNumber ? "?offset=" + pageNumber : "?"}` +
        `${
          pageSize ? "&pageSize=" + pageSize : ""
        }&data={%22isPublished%22%3Atrue}`
    );
  }

  getOneSdkRepo(sdkRepoId) {
    return this.instance.get("sdk-packages/" + sdkRepoId);
  }

  getPackageDownloadUrl(sdkRepoId, packageId) {
    return this.instance.get(
      "sdk-packages/" + sdkRepoId + "/package/" + packageId
    );
  }
}
